import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VCurrencyField from 'v-currency-field';
import { VTextField } from 'vuetify/lib';
import VueMask from 'v-mask';
import VueGtag from 'vue-gtag';

Vue.component('v-text-field', VTextField);

Vue.use(VueMask);

Vue.use(VCurrencyField, {
  locale: 'pt-BR',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: false,
});

if (process.env.VUE_APP_ENVIRONMENT === 'production') {
  const config = {
    id: 'G-ZEK74965FY',
    params: { send_page_view: false },
  };

  Vue.use(VueGtag, { config }, router);
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: function (h) {
    return h(App);
  },
}).$mount('#app');
